/**
 * The CRM theme for inline styles. Values live in src/theme.css; this file only
 * names them. `CRM` is the palette every screen's C / T object spreads, so a
 * style says C.accentFill (a primary button) or C.amberTint (a notice) and the
 * theme decides the colour. Not used by the client portals or documents.
 */

const v = (name: string) => `var(--crm-${name})`;

export const CRM = {
  bg: v('bg'),
  panel: v('panel'),
  panel2: v('panel-2'),
  border: v('line'),
  white: v('white'),
  text: v('text'),
  muted: v('muted'),
  dim: v('dim'),
  onFill: v('on-fill'),
  onGreen: v('on-green'),
  onAmber: v('on-amber'),

  accent: v('accent'),
  accentFill: v('accent-fill'),
  accentLine: v('accent-line'),
  accentTint: v('accent-tint'),
  accentSoftLine: v('accent-soft-line'),

  green: v('green'),
  greenFill: v('green-fill'),
  greenLine: v('green-line'),
  greenTint: v('green-tint'),
  greenSoftLine: v('green-soft-line'),

  amber: v('amber'),
  amberFill: v('amber-fill'),
  amberLine: v('amber-line'),
  amberTint: v('amber-tint'),
  amberSoftLine: v('amber-soft-line'),

  red: v('red'),
  redFill: v('red-fill'),
  redLine: v('red-line'),
  redTint: v('red-tint'),
  redSoftLine: v('red-soft-line'),

  violet: v('violet'),
  violetTint: v('violet-tint'),
  cyan: v('cyan'),
  teal: v('teal'),
  tealTint: v('teal-tint'),

  badge: v('badge'),
  badgeText: v('badge-text'),
  overlay: v('overlay'),
  shadowColor: v('shadow-color'),
  cardShadow: v('card-shadow'),
};

/**
 * A soft background / border for a colour chosen at run time (a tone prop, a
 * status map). For a known role use the CRM key instead (C.amberTint).
 */
export const tintOf = (color: string, pct = 12) => `color-mix(in srgb, ${color} ${pct}%, transparent)`;
